export const cities_hromada = [
  'Оріхів',
  'Копані',
  'Мирне',
  'Нестерянка',
  'Новоандріївка',
  'Новоданилівка',
  'Новопавлівка',
  'Щербаки',
]

export const streets = [
  {
    id: '1',
    city_name: 'Оріхів',
    label: '95 Гвардійської стрілецької дивізії, вулиця',
  },
  {
    id: '2',
    city_name: 'Оріхів',
    label: 'Академіка Вернадського, вулиця',
  },
  {
    id: '3',
    city_name: 'Оріхів',
    label: 'Берегова, вулиця',
  },
  {
    id: '4',
    city_name: 'Оріхів',
    label: 'Богдана Хмельницького, вулиця',
  },
  {
    id: '5',
    city_name: 'Оріхів',
    label: 'Вербна, вулиця',
  },
  {
    id: '6',
    city_name: 'Оріхів',
    label: 'Ветеринарна, вулиця',
  },
  {
    id: '7',
    city_name: 'Оріхів',
    label: 'Вишнева, вулиця',
  },
  {
    id: '8',
    city_name: 'Оріхів',
    label: 'Водопровідна, вулиця',
  },
  {
    id: '9',
    city_name: 'Оріхів',
    label: 'Гаражна, вулиця',
  },
  {
    id: '10',
    city_name: 'Оріхів',
    label: 'Героїв АТО, вулиця',
  },
  {
    id: '11',
    city_name: 'Оріхів',
    label: 'Героїв Крут, вулиця',
  },
  {
    id: '12',
    city_name: 'Оріхів',
    label: 'Гетьмана Сагайдачного, вулиця',
  },
  {
    id: '13',
    city_name: 'Оріхів',
    label: 'Гоголя, вулиця',
  },
  {
    id: '14',
    city_name: 'Оріхів',
    label: 'Горіхова, вулиця',
  },
  {
    id: '15',
    city_name: 'Оріхів',
    label: 'Громадянська, вулиця',
  },
  {
    id: '16',
    city_name: 'Оріхів',
    label: 'Дмитра Донцова, вулиця',
  },
  {
    id: '17',
    city_name: 'Оріхів',
    label: 'Елеваторна, вулиця',
  },
  {
    id: '18',
    city_name: 'Оріхів',
    label: 'Запорізька, вулиця',
  },
  {
    id: '19',
    city_name: 'Оріхів',
    label: 'Зарічна, вулиця',
  },
  {
    id: '20',
    city_name: 'Оріхів',
    label: 'Івана Богуна, вулиця',
  },
  {
    id: '21',
    city_name: 'Оріхів',
    label: 'Івана Мазепи, вулиця',
  },
  {
    id: '22',
    city_name: 'Оріхів',
    label: 'Йогана Янцена, вулиця',
  },
  {
    id: '23',
    city_name: 'Оріхів',
    label: "Кар'єрна, вулиця",
  },
  {
    id: '24',
    city_name: 'Оріхів',
    label: 'Каштанова, вулиця',
  },
  {
    id: '25',
    city_name: 'Оріхів',
    label: 'Квіткова, вулиця',
  },
  {
    id: '26',
    city_name: 'Оріхів',
    label: 'Київська, вулиця',
  },
  {
    id: '27',
    city_name: 'Оріхів',
    label: 'Кільцева, вулиця',
  },
  {
    id: '28',
    city_name: 'Оріхів',
    label: 'Кленова, вулиця',
  },
  {
    id: '29',
    city_name: 'Оріхів',
    label: 'Козача, вулиця',
  },
  {
    id: '30',
    city_name: 'Оріхів',
    label: 'Космічна, вулиця',
  },
  {
    id: '31',
    city_name: 'Оріхів',
    label: 'Лесі Українки, вулиця',
  },
  {
    id: '32',
    city_name: 'Оріхів',
    label: 'Лікаря Лукашевича, вулиця',
  },
  {
    id: '33',
    city_name: 'Оріхів',
    label: 'Лугова, вулиця',
  },
  {
    id: '34',
    city_name: 'Оріхів',
    label: 'Марії Сокіл, вулиця',
  },
  {
    id: '35',
    city_name: 'Оріхів',
    label: 'Машинотракторна, вулиця',
  },
  {
    id: '36',
    city_name: 'Оріхів',
    label: 'Металістів, вулиця',
  },
  {
    id: '37',
    city_name: 'Оріхів',
    label: 'Миколи Пелешка, вулиця',
  },
  {
    id: '38',
    city_name: 'Оріхів',
    label: 'Миру, вулиця',
  },
  {
    id: '39',
    city_name: 'Оріхів',
    label: 'Михайла Грушевського, вулиця',
  },
  {
    id: '40',
    city_name: 'Оріхів',
    label: 'Молодіжна, вулиця',
  },
  {
    id: '41',
    city_name: 'Оріхів',
    label: 'Новорічна, вулиця',
  },
  {
    id: '42',
    city_name: 'Оріхів',
    label: 'Овчаренка, вулиця',
  },
  {
    id: '43',
    city_name: 'Оріхів',
    label: 'Озерна, вулиця',
  },
  {
    id: '44',
    city_name: 'Оріхів',
    label: 'Павла Сергієнка, вулиця',
  },
  {
    id: '45',
    city_name: 'Оріхів',
    label: 'Паркова, вулиця',
  },
  {
    id: '46',
    city_name: 'Оріхів',
    label: 'Південна, вулиця',
  },
  {
    id: '47',
    city_name: 'Оріхів',
    label: 'Пісочна, вулиця',
  },
  {
    id: '48',
    city_name: 'Оріхів',
    label: 'Покровська, вулиця',
  },
  {
    id: '49',
    city_name: 'Оріхів',
    label: 'Польова, вулиця',
  },
  {
    id: '50',
    city_name: 'Оріхів',
    label: 'Привокзальна, вулиця',
  },
  {
    id: '51',
    city_name: 'Оріхів',
    label: 'Приходька, вулиця',
  },
  {
    id: '52',
    city_name: 'Оріхів',
    label: 'Різдвяна, вулиця',
  },
  {
    id: '53',
    city_name: 'Оріхів',
    label: 'Річна, вулиця',
  },
  {
    id: '54',
    city_name: 'Оріхів',
    label: 'Садова, вулиця',
  },
  {
    id: '55',
    city_name: 'Оріхів',
    label: 'Соборна, вулиця',
  },
  {
    id: '56',
    city_name: 'Оріхів',
    label: 'Сонячна, вулиця',
  },
  {
    id: '57',
    city_name: 'Оріхів',
    label: 'Спортивна, вулиця',
  },
  {
    id: '58',
    city_name: 'Оріхів',
    label: 'Стадіонна, вулиця',
  },
  {
    id: '59',
    city_name: 'Оріхів',
    label: 'Степна, вулиця',
  },
  {
    id: '60',
    city_name: 'Оріхів',
    label: 'Суворова, вулиця',
  },
  {
    id: '61',
    city_name: 'Оріхів',
    label: 'Таврійська, вулиця',
  },
  {
    id: '62',
    city_name: 'Оріхів',
    label: 'Тіниста, вулиця',
  },
  {
    id: '63',
    city_name: 'Оріхів',
    label: 'Травнева, вулиця',
  },
  {
    id: '64',
    city_name: 'Оріхів',
    label: 'Українська, вулиця',
  },
  {
    id: '65',
    city_name: 'Оріхів',
    label: 'Фестивальна, вулиця',
  },
  {
    id: '66',
    city_name: 'Оріхів',
    label: 'Франка, вулиця',
  },
  {
    id: '67',
    city_name: 'Оріхів',
    label: 'Центральна, вулиця',
  },
  {
    id: '68',
    city_name: 'Оріхів',
    label: 'Черемшина, вулиця',
  },
  {
    id: '69',
    city_name: 'Оріхів',
    label: 'Шевченка, вулиця',
  },
  {
    id: '70',
    city_name: 'Оріхів',
    label: 'Шовкова, вулиця',
  },
  {
    id: '71',
    city_name: 'Оріхів',
    label: 'Щаслива, вулиця',
  },
  {
    id: '72',
    city_name: 'Оріхів',
    label: 'Ювілейна, вулиця',
  },
  {
    id: '73',
    city_name: 'Оріхів',
    label: 'Академіка Вернадського, провулок',
  },
  {
    id: '74',
    city_name: 'Оріхів',
    label: 'Березовий, провулок',
  },
  {
    id: '75',
    city_name: 'Оріхів',
    label: 'Богдана Хмельницького, провулок',
  },
  {
    id: '76',
    city_name: 'Оріхів',
    label: 'Василя Стуса, провулок',
  },
  {
    id: '77',
    city_name: 'Оріхів',
    label: 'Весняний, провулок',
  },
  {
    id: '78',
    city_name: 'Оріхів',
    label: 'Вишневий, провулок',
  },
  {
    id: '79',
    city_name: 'Оріхів',
    label: 'Водопровідний, провулок',
  },
  {
    id: '80',
    city_name: 'Оріхів',
    label: 'Гагаріна, провулок',
  },
  {
    id: '81',
    city_name: 'Оріхів',
    label: 'Гвардійський, провулок',
  },
  {
    id: '82',
    city_name: 'Оріхів',
    label: 'Героїв АТО, провулок',
  },
  {
    id: '83',
    city_name: 'Оріхів',
    label: 'Гетьмана Сагайдачного, провулок',
  },
  {
    id: '84',
    city_name: 'Оріхів',
    label: 'Гоголя, провулок',
  },
  {
    id: '85',
    city_name: 'Оріхів',
    label: 'Громадянський, провулок',
  },
  {
    id: '86',
    city_name: 'Оріхів',
    label: 'Дачний, провулок',
  },
  {
    id: '87',
    city_name: 'Оріхів',
    label: 'Дмитра Донцова, провулок',
  },
  {
    id: '88',
    city_name: 'Оріхів',
    label: 'Дружби, провулок',
  },
  {
    id: '89',
    city_name: 'Оріхів',
    label: 'Дружний, провулок',
  },
  {
    id: '90',
    city_name: 'Оріхів',
    label: 'Елеваторний, провулок',
  },
  {
    id: '91',
    city_name: 'Оріхів',
    label: 'Енергетиків, провулок',
  },
  {
    id: '92',
    city_name: 'Оріхів',
    label: 'Заводський, провулок',
  },
  {
    id: '93',
    city_name: 'Оріхів',
    label: 'Залізничний, провулок',
  },
  {
    id: '94',
    city_name: 'Оріхів',
    label: 'Зелений, провулок',
  },
  {
    id: '95',
    city_name: 'Оріхів',
    label: "Зої Космодем'янської, провулок",
  },
  {
    id: '96',
    city_name: 'Оріхів',
    label: 'Йогана Янцена, провулок',
  },
  {
    id: '97',
    city_name: 'Оріхів',
    label: 'Квітковий, провулок',
  },
  {
    id: '98',
    city_name: 'Оріхів',
    label: 'Комарова, провулок',
  },
  {
    id: '99',
    city_name: 'Оріхів',
    label: 'Космічний, провулок',
  },
  {
    id: '100',
    city_name: 'Оріхів',
    label: 'Лермонтова, провулок',
  },
  {
    id: '101',
    city_name: 'Оріхів',
    label: 'Лесі Українки, провулок',
  },
  {
    id: '102',
    city_name: 'Оріхів',
    label: 'Лізи Чайкіної, провулок',
  },
  {
    id: '103',
    city_name: 'Оріхів',
    label: 'Луговий, провулок',
  },
  {
    id: '104',
    city_name: 'Оріхів',
    label: 'Марії Сокіл, провулок',
  },
  {
    id: '105',
    city_name: 'Оріхів',
    label: 'Матросова, провулок',
  },
  {
    id: '106',
    city_name: 'Оріхів',
    label: 'Машинотракторний, провулок',
  },
  {
    id: '107',
    city_name: 'Оріхів',
    label: 'Металістів, провулок',
  },
  {
    id: '108',
    city_name: 'Оріхів',
    label: 'Мирний, провулок',
  },
  {
    id: '109',
    city_name: 'Оріхів',
    label: 'Наскрізний, провулок',
  },
  {
    id: '110',
    city_name: 'Оріхів',
    label: 'Новий, провулок',
  },
  {
    id: '111',
    city_name: 'Оріхів',
    label: 'Олега Кошового, провулок',
  },
  {
    id: '112',
    city_name: 'Оріхів',
    label: 'Олімпійський, провулок',
  },
  {
    id: '113',
    city_name: 'Оріхів',
    label: 'Оріхівський, провулок',
  },
  {
    id: '114',
    city_name: 'Оріхів',
    label: 'Партизан, провулок',
  },
  {
    id: '115',
    city_name: 'Оріхів',
    label: 'Перемоги, провулок',
  },
  {
    id: '116',
    city_name: 'Оріхів',
    label: 'Пісочний, провулок',
  },
  {
    id: '117',
    city_name: 'Оріхів',
    label: 'Покровський, провулок',
  },
  {
    id: '118',
    city_name: 'Оріхів',
    label: 'Привокзальний, провулок',
  },
  {
    id: '119',
    city_name: 'Оріхів',
    label: 'Пушкіна, провулок',
  },
  {
    id: '120',
    city_name: 'Оріхів',
    label: 'Райдужний, провулок',
  },
  {
    id: '121',
    city_name: 'Оріхів',
    label: 'Робочий, провулок',
  },
  {
    id: '122',
    city_name: 'Оріхів',
    label: 'Садовий, провулок',
  },
  {
    id: '123',
    city_name: 'Оріхів',
    label: 'Соборний, провулок',
  },
  {
    id: '124',
    city_name: 'Оріхів',
    label: 'Сонячний, провулок',
  },
  {
    id: '125',
    city_name: 'Оріхів',
    label: 'Стадіонний, провулок',
  },
  {
    id: '126',
    city_name: 'Оріхів',
    label: 'Суворова, провулок',
  },
  {
    id: '127',
    city_name: 'Оріхів',
    label: 'Таврійський, провулок',
  },
  {
    id: '128',
    city_name: 'Оріхів',
    label: 'Тихий, провулок',
  },
  {
    id: '129',
    city_name: 'Оріхів',
    label: 'Травневий, провулок',
  },
  {
    id: '130',
    city_name: 'Оріхів',
    label: 'Тупиковий, провулок',
  },
  {
    id: '131',
    city_name: 'Оріхів',
    label: 'Український, провулок',
  },
  {
    id: '132',
    city_name: 'Оріхів',
    label: 'Фестивальний, провулок',
  },
  {
    id: '133',
    city_name: 'Оріхів',
    label: 'Чайковського, провулок',
  },
  {
    id: '134',
    city_name: 'Оріхів',
    label: 'Чарівний, провулок',
  },
  {
    id: '135',
    city_name: 'Оріхів',
    label: 'Шевченка, провулок',
  },
  {
    id: '136',
    city_name: 'Оріхів',
    label: 'Шкільний, провулок',
  },
  {
    id: '137',
    city_name: 'Оріхів',
    label: 'Ювілейний, провулок',
  },
  {
    id: '138',
    city_name: 'Оріхів',
    label: 'Юрія Смірнова, провулок',
  },
  {
    id: '139',
    city_name: 'Копані',
    label: 'Академіка Малої, вулиця',
  },
  {
    id: '140',
    city_name: 'Копані',
    label: 'Вишнева, вулиця',
  },
  {
    id: '141',
    city_name: 'Копані',
    label: 'Гагаріна, вулиця',
  },
  {
    id: '142',
    city_name: 'Копані',
    label: 'Лугова, вулиця',
  },
  {
    id: '143',
    city_name: 'Копані',
    label: 'Миру, вулиця',
  },
  {
    id: '144',
    city_name: 'Копані',
    label: 'Новоселів, вулиця',
  },
  {
    id: '145',
    city_name: 'Копані',
    label: 'Патріотів, вулиця',
  },
  {
    id: '146',
    city_name: 'Копані',
    label: 'Першотравнева, вулиця',
  },
  {
    id: '147',
    city_name: 'Копані',
    label: 'Садова, вулиця',
  },
  {
    id: '148',
    city_name: 'Копані',
    label: 'Степна, вулиця',
  },
  {
    id: '149',
    city_name: 'Копані',
    label: 'Центральна, вулиця',
  },
  {
    id: '150',
    city_name: 'Копані',
    label: 'Чарівна, вулиця',
  },
  {
    id: '151',
    city_name: 'Копані',
    label: 'Шевченка, вулиця',
  },
  {
    id: '152',
    city_name: 'Копані',
    label: 'Шкільна, вулиця',
  },
  {
    id: '153',
    city_name: 'Копані',
    label: 'Ювілейна, вулиця',
  },
  {
    id: '154',
    city_name: 'Мирне',
    label: 'Василівська, вулиця',
  },
  {
    id: '155',
    city_name: 'Мирне',
    label: 'Виноградна, вулиця',
  },
  {
    id: '156',
    city_name: 'Мирне',
    label: 'Вишнева, вулиця',
  },
  {
    id: '157',
    city_name: 'Мирне',
    label: 'Вороніна, вулиця',
  },
  {
    id: '158',
    city_name: 'Мирне',
    label: 'Гвардійська, вулиця',
  },
  {
    id: '159',
    city_name: 'Мирне',
    label: 'Запорізька, вулиця',
  },
  {
    id: '160',
    city_name: 'Мирне',
    label: 'Космічна, вулиця',
  },
  {
    id: '161',
    city_name: 'Мирне',
    label: 'Миру, вулиця',
  },
  {
    id: '162',
    city_name: 'Мирне',
    label: 'Молодіжна, вулиця',
  },
  {
    id: '163',
    city_name: 'Мирне',
    label: 'Перемоги, вулиця',
  },
  {
    id: '164',
    city_name: 'Мирне',
    label: 'Радянська, вулиця',
  },
  {
    id: '165',
    city_name: 'Мирне',
    label: 'Садова, вулиця',
  },
  {
    id: '166',
    city_name: 'Мирне',
    label: 'Соціалістична, вулиця',
  },
  {
    id: '167',
    city_name: 'Мирне',
    label: 'Степова, вулиця',
  },
  {
    id: '168',
    city_name: 'Мирне',
    label: 'Українська, вулиця',
  },
  {
    id: '169',
    city_name: 'Мирне',
    label: 'Фермерська, вулиця',
  },
  {
    id: '170',
    city_name: 'Мирне',
    label: 'Яссана, вулиця',
  },
  {
    id: '171',
    city_name: 'Нестерянка',
    label: '40 років Перемоги, вулиця',
  },
  {
    id: '172',
    city_name: 'Нестерянка',
    label: 'Вишнева, вулиця',
  },
  {
    id: '173',
    city_name: 'Нестерянка',
    label: 'Волі, вулиця',
  },
  {
    id: '174',
    city_name: 'Нестерянка',
    label: 'Гвардійська, вулиця',
  },
  {
    id: '175',
    city_name: 'Нестерянка',
    label: 'Миру, вулиця',
  },
  {
    id: '176',
    city_name: 'Нестерянка',
    label: 'Олімпійська, вулиця',
  },
  {
    id: '177',
    city_name: 'Нестерянка',
    label: 'Оріхівська, вулиця',
  },
  {
    id: '178',
    city_name: 'Нестерянка',
    label: 'Патріотична, вулиця',
  },
  {
    id: '179',
    city_name: 'Нестерянка',
    label: 'Південна, вулиця',
  },
  {
    id: '180',
    city_name: 'Нестерянка',
    label: 'Плодорозсадник, вулиця',
  },
  {
    id: '181',
    city_name: 'Нестерянка',
    label: 'Польова, вулиця',
  },
  {
    id: '182',
    city_name: 'Нестерянка',
    label: 'Сергія Падалка, вулиця',
  },
  {
    id: '183',
    city_name: 'Нестерянка',
    label: 'Центральна, вулиця',
  },
  {
    id: '184',
    city_name: 'Нестерянка',
    label: 'Шкільна, вулиця',
  },
  {
    id: '185',
    city_name: 'Нестерянка',
    label: 'Ювілейна, вулиця',
  },
  {
    id: '186',
    city_name: 'Новоандріївка',
    label: 'Вишнева, вулиця',
  },
  {
    id: '187',
    city_name: 'Новоандріївка',
    label: 'Гагаріна, вулиця',
  },
  {
    id: '188',
    city_name: 'Новоандріївка',
    label: 'Клименко, вулиця',
  },
  {
    id: '189',
    city_name: 'Новоандріївка',
    label: 'Космічна, вулиця',
  },
  {
    id: '190',
    city_name: 'Новоандріївка',
    label: 'Шкільний, провулок',
  },
  {
    id: '191',
    city_name: 'Новоданилівка',
    label: 'Вишнева, вулиця',
  },
  {
    id: '192',
    city_name: 'Новоданилівка',
    label: 'Лугова, вулиця',
  },
  {
    id: '193',
    city_name: 'Новоданилівка',
    label: 'Миру, вулиця',
  },
  {
    id: '194',
    city_name: 'Новоданилівка',
    label: 'Молодіжна, вулиця',
  },
  {
    id: '195',
    city_name: 'Новоданилівка',
    label: 'Первомайська, вулиця',
  },
  {
    id: '196',
    city_name: 'Новоданилівка',
    label: 'Плодорозсадник, вулиця',
  },
  {
    id: '197',
    city_name: 'Новоданилівка',
    label: 'Садова, вулиця',
  },
  {
    id: '198',
    city_name: 'Новоданилівка',
    label: 'Хрусталькова, вулиця',
  },
  {
    id: '199',
    city_name: 'Новоданилівка',
    label: 'Чарівна, вулиця',
  },
  {
    id: '200',
    city_name: 'Новоданилівка',
    label: 'Южна, вулиця',
  },
  {
    id: '201',
    city_name: 'Новоданилівка',
    label: 'Тихий, провулок',
  },
  {
    id: '202',
    city_name: 'Новопавлівка',
    label: 'Вишнева, вулиця',
  },
  {
    id: '203',
    city_name: 'Новопавлівка',
    label: 'Жовтнева, вулиця',
  },
  {
    id: '204',
    city_name: 'Новопавлівка',
    label: 'Лугова, вулиця',
  },
  {
    id: '205',
    city_name: 'Новопавлівка',
    label: 'Першотравнева, вулиця',
  },
  {
    id: '206',
    city_name: 'Новопавлівка',
    label: 'Суворова, вулиця',
  },
  {
    id: '207',
    city_name: 'Новопавлівка',
    label: 'Чарівна, вулиця',
  },
  {
    id: '208',
    city_name: 'Новопавлівка',
    label: 'Шевченка, вулиця',
  },
  {
    id: '209',
    city_name: 'Новопавлівка',
    label: 'Галустяна, провулок',
  },
  {
    id: '210',
    city_name: 'Щербаки',
    label: 'Бурдіна, вулиця',
  },
  {
    id: '211',
    city_name: 'Щербаки',
    label: 'Верхня, вулиця',
  },
  {
    id: '212',
    city_name: 'Щербаки',
    label: 'Степова, вулиця',
  },
  {
    id: '213',
    city_name: 'Щербаки',
    label: 'Тракторна, вулиця',
  },
]

export const vpo_cities = [
  'с. Андріївка',
  'с. Бабурка',
  'с-ще Балабине',
  'с. Біленьке',
  'с. Богатирівка',
  'с. Василівське',
  'с. Веселе',
  'с. Відрадне',
  'с. Вільноуланівське',
  'м. Вільнянськ',
  'с. Володимирівське',
  'с. Григорівське',
  'с. Дерезівка',
  'с. Дніпровка',
  'с. Долинське',
  'с. Заливне',
  'м. Запоріжжя',
  'с-ще Зарічне',
  'с. Зоряне',
  "с-ще Кам'яне",
  'с. Канівське',
  'с-ще Кирпотине',
  'с. Криничне',
  'с. Купріянівка',
  'с-ще Кушугум',
  'с. Лежене',
  'с. Лисогірка',
  'с. Лукашеве',
  'с. Любимівка',
  'с. Люцерна',
  'с-ще Малокатеринівка',
  'с. Малоолександрівка',
  'с. Матвіївка',
  'с. Михайлівка',
  'с. Надія',
  'с. Нове',
  'с-ще Новомиколаївка',
  'с. Новоолександрівка',
  'с. Новопетрівка',
  'с. Новософіївка',
  'с. Новотавричеська',
  'с. Новотроїцьке',
  'м. Оріхів',
  'с. Острівське',
  'с. Петропіль',
  'с. Привільне',
  'с-ще Растуще',
  'с. Розумівка',
  'с. Ростуще',
  'с. Ружин',
  'с. Синельникове',
  'с. Соколівка',
  'с-ще Сонячне',
  'с. Степне',
  'с. Таврійське',
  'с. Широке',
  'с. Юрківка',
]

export const vpo_streets = [
  "бульв. Бельфорський", 
  "бульв. Будівельників", 
  "бульв. Вінтера", 
  "бульв. Вітчизняний", 
  "бульв. Гвардійський", 
  "бульв. Марії Примаченко",
  "бульв. Парковий",
  "бульв. Центральний",
  "бульв. Шевченка",
  "вул. 12 квітня",
  "вул. 14 жовтня",
  "вул. 8 березня",
  "вул. Абразивна",
  "вул. Абрикосова",
  "вул. Аваліані",
  "вул. Авіаційна",
  "вул. Авраменка",
  "вул. Автозаводська",
  "вул. Автострадна",
  "вул. Адмірала Макарова",
  "вул. Адміралтейська",
  "вул. Азовська",
  "вул. Айвазовського",
  "вул. Айнлагська",
  "вул. Академіка Александрова",
  "вул. Академіка Амосова",
  "вул. Академіка Вернадського",
  "вул. Академіка Чабаненка",
  "вул. Алма-Атинська",
  "вул. Алмазна",
  "вул. Алтайська",
  "вул. Аматорська",
  "вул. Амбулаторна",
  "вул. Анапська",
  "вул. Ангська",
  "вул. Антарктична",
  "вул. Аральська",
  "вул. Арктична",
  "вул. Армавірська",
  "вул. Армійська",
  "вул. Артилеристів",
  "вул. Архітектурна",
  "вул. Базарна",
  "вул. Базова",
  "вул. Байди",
  "вул. Балка Поповка",
  "вул. Банківська",
  "вул. Баранова",
  "вул. Барвиста",
  "вул. Барикадна",
  "вул. Басейна",
  "вул. Благовіщенська",
  "вул. Богдана Завади",
  "вул. Богдана Хмельницького",
  "вул. Бойко",
  "вул. Болбочана Петра",
  "вул. Бориса Грінченка",
  "вул. Бочарова",
  "вул. Братська",
  "вул. Броньова",
  "вул. Брюлова",
  "вул. Будинок відпочинку",
  "вул. Будівельна",
  "вул. Будівельників",
  "вул. Буревісника",
  "вул. Вавілова",
  "вул. Вагонна",
  "вул. Валерія Лобановського",
  "вул. Варнацька",
  "вул. Васильєва",
  "вул. Василя Сергієнка",
  "вул. Вахтова",
  "вул. Вербова",
  "вул. Верхня",
  "вул. Весняна",
  "вул. Виборзька",
  "вул. Виноградна",
  "вул. Виробнича",
  "вул. Вишнева",
  "вул. Вишневського",
  "вул. Відродження",
  "вул. Військбуд",
  "вул. Військоматська",
  "вул. Віктора Духовченка",
  "вул. Вільнюська",
  "вул. Вінтера",
  "вул. Вітряна",
  "вул. Водограйна",
  "вул. Водозабірна",
  "вул. Возз'єднання України",
  "вул. Волгоградська",
  "вул. Волі",
  "вул. Володимира Грищенка",
  "вул. Володимира Мономаха",
  "вул. Володимира Українця",
  "вул. Володимира Ященка",
  "вул. Володимирська",
  "вул. Волоколамська",
  "вул. Волькая",
  "вул. Воронезька",
  "вул. Вороніна",
  "вул. Вроцлавська",
  "вул. Вузівська",
  "вул. Вузькоколійна",
  "вул. Вятська",
  "вул. Вячеслава Зайцева",
  "вул. Гагаріна",
  "вул. Гарнізонна",
  "вул. Гастелло",
  "вул. Генераторна",
  "вул. Георгія Нелюбова",
  "вул. Героїв 37-го Батальону",
  "вул. Героїв 55-ї бригади",
  "вул. Героїв 93-ї Бригади",
  "вул. Героїв Дніпра",
  "вул. Героїв полку Азов",
  "вул. Глазунова",
  "вул. Глєбова",
  "вул. Глісерна",
  "вул. Гоголя",
  "вул. Гончара",
  "вул. Гончарова",
  "вул. Горіхівська",
  "вул. Горіхова Бухта",
  "вул. Городська",
  "вул. Горького",
  "вул. Господарча",
  "вул. Гребельна",
  "вул. Грибова",
  "вул. Грибоєдова",
  "вул. Григорія Квітки-Основ'яненка",
  "вул. Григорія Нелюбова",
  "вул. Гризодубової",
  "вул. Грушевського",
  "вул. Дальня",
  "вул. Дачна",
  "вул. Дегтярьова",
  "вул. Дежнєва",
  "вул. Демократична",
  "вул. Деповська",
  "вул. Державіна",
  "вул. Дизельна",
  "вул. Дмитра Апухтіна",
  "вул. Дмитра Вишневецького",
  "вул. Дмитра Коцюбайла",
  "вул. Дмитра Миргородського",
  "вул. Дніпровська",
  "вул. Дніпровське шосе",
  "вул. Дніпровські зорі",
  "вул. Дніпровські пороги",
  "вул. Доблесна",
  "вул. Добробутна",
  "вул. Добровольчих батальйонів",
  "вул. Добролюбова",
  "вул. Довженка",
  "вул. Долинна",
  "вул. Донбаська",
  "вул. Дорошенка",
  "вул. Дослідна",
  "вул. Дослідна станція",
  "вул. Дружби",
  "вул. Дружна",
  "вул. Дубова",
  "вул. Дудикіна",
  "вул. Дунайська",
  "вул. Електрична",
  "вул. Ентузіастів",
  "вул. Євгена Адамцевича",
  "вул. Європейська",
  "вул. Єнісейська",
  "вул. Жемчужна",
  "вул. Житомирська",
  "вул. Жуковського",
  "вул. Завади Богдана",
  "вул. Заводська",
  "вул. Закарпатська",
  "вул. Закарпатського легіону",
  "вул. Залізнична",
  "вул. Залізничні будинки",
  "вул. Замкнута",
  "вул. Заполярна",
  "вул. Запоріжбудівська",
  "вул. Запорізька",
  "вул. Запорізького козацтва",
  "вул. Західна",
  "вул. Зачиняєва",
  "вул. Звенигородська",
  "вул. Звільнена",
  "вул. Зелена",
  "вул. Зелінського",
  "вул. Земського лікаря Лукашевича",
  "вул. Зернова",
  "вул. Зестафонська",
  "вул. Зорепадна",
  "вул. Зоряна",
  "вул. Зразкова",
  "вул. Івана Богуна",
  "вул. Івана Гутніка-Залужного",
  "вул. Івана Мазепи",
  "вул. Івана Нечуй-Левицького",
  "вул. Івана Огієнка",
  "вул. Івана Чупілка",
  "вул. Івана Шкоди",
  "вул. Іванівська",
  "вул. Іванова",
  "вул. Ігоря Сікорського",
  "вул. Ізвивиста",
  "вул. Ізмаїльська",
  "вул. Інженера Преображенського",
  "вул. Інститутська",
  "вул. Іскри",
  "вул. Істоміна",
  "вул. Історична",
  "вул. Калинівська",
  "вул. Калнишевського",
  "вул. Кам'яна",
  "вул. Канівська",
  "вул. Карпенка-Карого",
  "вул. Карпинського",
  "вул. Каспійська",
  "вул. Каховська",
  "вул. Каштанова",
  "вул. Квіткова",
  "вул. Квітуча",
  "вул. Кибальчична",
  "вул. Кияшка",
  "вул. Ключова",
  "вул. Княжа",
  "вул. Коврова",
  "вул. Козака Бабури",
  "вул. Козача",
  "вул. Комарова",
  "вул. Компресорна",
  "вул. Корищенка",
  "вул. Косміна",
  "вул. Космічна",
  "вул. Костя Гордієнка",
  "вул. Костянтина Великого",
  "вул. Котляревського",
  "вул. Кочубея",
  "вул. Кошова",
  "вул. Краєвидна",
  "вул. Крайня",
  "вул. Крайова",
  "вул. Краматорська",
  "вул. Краснова",
  "вул. Кремено",
  "вул. Кривоносова",
  "вул. Криворізька",
  "вул. Кругова",
  "вул. Культурна",
  "вул. Курортна",
  "вул. Курська",
  "вул. Курузова",
  "вул. Кутузова",
  "вул. Лазаретна",
  "вул. Лассаля",
  "вул. Латвійська",
  "вул. Лахтінська",
  "вул. Левка Лукьяненка",
  "вул. Легендарна",
  "вул. Ленська",
  "вул. Леоніда Жаботинського",
  "вул. Леонтовича",
  "вул. Лермонтова",
  "вул. Липовецька",
  "вул. Лівобережна",
  "вул. Лікарська",
  "вул. Лікаря Лукашевича",
  "вул. Лірична",
  "вул. Лугова",
  "вул. Любисткова",
  "вул. Магара",
  "вул. Магістральна",
  "вул. Максима Кривоноса",
  "вул. Мала",
  "вул. Малахітна",
  "вул. Малика",
  "вул. Мальв",
  "вул. Мальовнича",
  "вул. Марії Примаченко",
  "вул. Маршала Судця",
  "вул. Машинна",
  "вул. Медична",
  "вул. Меліоративна",
  "вул. Мендєлєєва",
  "вул. Метрополітенівська",
  "вул. Мечникова",
  "вул. Микола Ласточкіна",
  "вул. Миколи Киценка",
  "вул. Миколи Корищенка",
  "вул. Миколи Краснова",
  "вул. Миколи Ласточкіна",
  "вул. Мирна",
  "вул. Миру",
  "вул. Митрополита Шептицького",
  "вул. Михайла Гончаренка",
  "вул. Михайла Грушевського",
  "вул. Михайла Топоркова",
  "вул. Михайлова",
  "вул. Міжнародна",
  "вул. Міклея",
  "вул. Мінська",
  "вул. Міцна",
  "вул. МКДЗ-2",
  "вул. Мокрянська",
  "вул. Молдавська",
  "вул. Молодіжна",
  "вул. Молодогвардійська",
  "вул. Молочна",
  "вул. Морфлотська",
  "вул. Мостова",
  "вул. Моторобудівників",
  "вул. Мохова",
  "вул. Мрії",
  "вул. Музикальна",
  "вул. Музична",
  "вул. Мурманська",
  "вул. Мусорського",
  "вул. Набережна",
  "вул. Нагнибіди",
  "вул. Нагорна",
  "вул. Надії",
  "вул. Наукового містечка",
  "вул. Незалежної України",
  "вул. Нижньодніпровська",
  "вул. Ніжинська",
  "вул. Нова",
  "вул. Новаторська",
  "вул. Новгородська",
  "вул. Новокузнецька",
  "вул. Новоросійська",
  "вул. Новочеркаська",
  "вул. Норильська",
  "вул. Оборонна",
  "вул. Одеська",
  "вул. Озерна",
  "вул. Олександра Говорухи",
  "вул. Олександрівська",
  "вул. Олексія Поради",
  "вул. Олени Теліги",
  "вул. Олімпійська",
  "вул. Олімпійька",
  "вул. Ольги Кобилянської",
  "вул. Омельченка",
  "вул. Оптимістична",
  "вул. Оріхівське шосе",
  "вул. Осипенко",
  "вул. Осіння",
  "вул. Основна",
  "вул. Офіцерська",
  "вул. Очаківська",
  "вул. Павла Сиромятникова",
  "вул. Павла Чубинського",
  "вул. Павлокічкаська",
  "вул. Памірська",
  "вул. Панаса Мирного",
  "вул. Пантелеймона Куліша",
  "вул. Панфьорова",
  "вул. Паралельна",
  "вул. Парамонова",
  "вул. Паркова",
  "вул. Партизанська",
  "вул. Пархоменка",
  "вул. Паторжинського",
  "вул. Патріотична",
  "вул. Пахоменка",
  "вул. Передатна",
  "вул. Перемоги",
  "вул. Перспективна",
  "вул. Перша Ливарна",
  "вул. Першотравнева",
  "вул. Петемоги",
  "вул. Петра Болбочана",
  "вул. Петра Дорошенка",
  "вул. Петра Сагайдачного",
  "вул. Південна",
  "вул. Південне шосе",
  "вул. Південноукраїнська",
  "вул. Північне шосе",
  "вул. Північнокільцева",
  "вул. Пітера Леппа",
  "вул. Планерна",
  "вул. Пожарського",
  "вул. Покровська",
  "вул. Пологівська",
  "вул. Полтавська",
  "вул. Польова",
  "вул. Полякова",
  "вул. Попова",
  "вул. Портова",
  "вул. Поточна",
  "вул. Поштов",
  "вул. Поштова",
  "вул. Престижна",
  "вул. Приватна",
  "вул. Привокзальна",
  "вул. Приходська",
  "вул. Причальна",
  "вул. Промислова",
  "вул. Професора Анатолія Бойка",
  "вул. Професора Толока",
  "вул. Профспілкова",
  "вул. Пугачова",
  "вул. Радищева",
  "вул. Радіаторна",
  "вул. Радіо",
  "вул. Ракетна",
  "вул. Рекордна",
  "вул. Рельєфна",
  "вул. Республіканська",
  "вул. Річкова",
  "вул. Рози",
  "вул. Романтична",
  "вул. Рубана",
  "вул. Руставелі",
  "вул. Руставі",
  "вул. Рязанська",
  "вул. Рясна",
  "вул. Садівництва - Хортиця",
  "вул. Садова",
  "вул. Санаторна",
  "вул. Саперна",
  "вул. Сахалінська",
  "вул. Світла",
  "вул. Світловодська",
  "вул. Святоволодимирівська",
  "вул. Святогірська",
  "вул. Святого Миколая",
  "вул. Селищна",
  "вул. Сергієнка Василя",
  "вул. Сергія Синенка",
  "вул. Сеченова",
  "вул. Сєдова",
  "вул. Силова",
  "вул. Синельниковська",
  "вул. Ситова",
  "вул. Сікорського",
  "вул. Січ",
  "вул. Січових стрільців",
  "вул. Скворцова",
  "вул. Скіфська",
  "вул. Складська",
  "вул. Славутича",
  "вул. Сланцева",
  "вул. Слободчикова",
  "вул. Слов'янська",
  "вул. Солідарності",
  "вул. Солов'їна",
  "вул. Сонячна",
  "вул. Сорочинська",
  "вул. Соснова",
  "вул. Софіївська",
  "вул. Спартака Маковського",
  "вул. Сталевара Галушки",
  "вул. Сталеварів",
  "вул. Станіславського",
  "вул. Стародніпровська",
  "вул. Степана Разіна",
  "вул. Степанова",
  "вул. Степна",
  "вул. Степова",
  "вул. Стефанова",
  "вул. Стешенка",
  "вул. Столярна",
  "вул. Стратосферна",
  "вул. Стрєльнікова",
  "вул. Студентська",
  "вул. Судова",
  "вул. Суха Балка",
  "вул. Східна",
  "вул. Таврична",
  "вул. Талаліхіна",
  "вул. Таллінська",
  "вул. Танкістів",
  "вул. Тбіліська",
  "вул. Тверська",
  "вул. Тенісна",
  "вул. Теплохідна",
  "вул. Технічна",
  "вул. Тімірязєва",
  "вул. Товариська",
  "вул. Тополіна",
  "вул. Тракторна",
  "вул. Транспортна",
  "вул. Трансформаторників",
  "вул. Трегубенка",
  "вул. Трегубова",
  "вул. Троїцька",
  "вул. Тушинська",
  "вул. Тяпкова",
  "вул. Узбекістанська",
  "вул. Українська",
  "вул. Університетська",
  "вул. Урожайна",
  "вул. Фабрична",
  "вул. Фанатська",
  "вул. Фелікса Мовчановського",
  "вул. Ферганська",
  "вул. Фестивальна",
  "вул. Фільтрова",
  "вул. Фінальна",
  "вул. Фінансова",
  "вул. Фортечна",
  "вул. Фортова",
  "вул. Франка",
  "вул. Фундаментальна",
  "вул. Хакаська",
  "вул. Халтуріна",
  "вул. Харківська",
  "вул. Харчова",
  "вул. Хлібна",
  "вул. Хортицьке шосе",
  "вул. Цегельна",
  "вул. Цегляна",
  "вул. Центральна",
  "вул. Цитрусова",
  "вул. Цілинна",
  "вул. Чайковського",
  "вул. Чамаченка",
  "вул. Чарівна",
  "вул. Червона",
  "вул. Червонополянська",
  "вул. Чернишевського",
  "вул. Чернівецька",
  "вул. Чернігівська",
  "вул. Чернова",
  "вул. Чкалова",
  "вул. Чонгарська",
  "вул. Чорноволенко",
  "вул. Чорноземна",
  "вул. Чорноморська",
  "вул. Чудова",
  "вул. Чумацький шлях",
  "вул. Чумаченка",
  "вул. Шевченка",
  "вул. Шенвізька",
  "вул. Шкільна",
  "вул. Штурмова",
  "вул. Щаслива",
  "вул. Ювілейна",
  "вул. Юності",
  "вул. Юрія Кондратюка",
  "вул. Юрія Шульте",
  "вул. Яворницького",
  "вул. Якова Новицького",
  "вул. Якова Пункіна",
  "вул. Ялтинська",
  "вул. Янтарна",
  "вул. Ярова",
  "вул. Яценка",
  "Запоріжжя",
  "пров. Амбулаторний",
  "пров. Берінга",
  "пров. Братський",
  "пров. Весняний",
  "пров. Вихідний",
  "пров. Вогневий",
  "пров. Гурзуфський",
  "пров. Дружний проїзд",
  "пров. Дружній проїзд",
  "пров. Кавалерійський",
  "пров. Квітковий",
  "пров. Квітучий",
  "пров. Ковальський",
  "пров. Конденсаторний",
  "пров. Кривий",
  "пров. Кришталевий",
  "пров. Кубинський",
  "пров. Мармуровий",
  "пров. Миколаївський",
  "пров. Мозаїчний",
  "пров. Морський",
  "пров. Новий",
  "пров. Озерний",
  "пров. Оранжерейний",
  "пров. Охайний",
  "пров. Палія",
  "пров. Перемоги",
  "пров. Прибережний",
  "пров. Прохолодний",
  "пров. Ржевський",
  "пров. Світловий",
  "пров. Сочінський",
  "пров. Ставропільський",
  "пров. Сталевий",
  "пров. Суміжний",
  "пров. Сюрпризний",
  "пров. Технічний",
  "пров. Тихий",
  "пров. Упорний",
  "пров. Художній",
  "пров. Шахтарський",
  "пров. Шкільний",
  "пров. Явірний",
  "пров. Ямський",
  "проїзд Дружний",
  "просп. Героїв Національної гвардії України",
  "просп. Інженера Преображенського",
  "просп. Маяковського",
  "просп. Металургів",
  "просп. Моторобудівників",
  "просп. Соборний",
  "просп. Ювілейний"
]
